import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { ClassificationCModel } from 'src/app/models/ClassificationCModel';
import { ClassificationCService } from 'src/app/services/ClassificationCService';


@Component({
  selector: 'app-cont-class-search',
  templateUrl: './cont-class-search.component.html',
  styleUrls: ['./cont-class-search.component.css']
})
export class ContClassSearchComponent implements OnInit {
  clasCCode ='' ;
  clasCName ='' ;
  clasCNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';
  ContClassList : ClassificationCModel[]=[]
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<ContClassSearchComponent>,   ///----------- for searching pop up -----------
              public contclassservice: ClassificationCService,
              public contclass: ClassificationCModel,
              public storage: LocalStorageService,
              @Inject(MAT_DIALOG_DATA)                                  ///----------- for searching pop up -----------
              public contclassSelectedData: ClassificationCModel) { }

  ngOnInit(): void {
    this.retriveContClassLookupTop();
  }
  retriveDoctorsLookup(){}
  retriveContClassLookupTop(){
    this.ContClassList = [];
    this.contclassservice.getClassificationCLookupTop(this.compCode).subscribe((data: ClassificationCModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ContClassList[i] = data[i];
      }
    })
  }
  SelectContClass(Do :ClassificationCModel){
    this.contclassSelectedData.clasCCode = Do.clasCCode
    this.contclassSelectedData.clasCName = Do.clasCName
    this.contclassSelectedData.clasCNotes = Do.clasCNotes


    this.contclassSelectedData.userID = Do.userID
    this.contclassSelectedData.modifaiedDate = Do.modifaiedDate
    this.contclassSelectedData.compCode = Do.compCode
    this.submitClicked.emit(this.contclassSelectedData);
    this.dialogRef.close();
  }
}
